// @flow
import React from 'react';
import styled from 'styled-components';
import DatePicker from 'antd/lib/date-picker';
import moment from 'moment';

import { formatDateTimeToISOString } from '../../../lib/helpers';

import {
  Filter,
  FilterContainer,
  FilterItem,
  FilterButtonsContainer
} from '../../../components';
import type { FilterChildrenParams } from '../../../components/hoc/Filter';
import Field from '../../../components/card/Field';

const SpoilerContent = styled.div`
  padding: 16px;
`;
const { RangePicker } = DatePicker;
export type VehicleMonitoringFilterParams = {
  startDate?: string | moment,
  endDate?: string | moment
};

type Props = {
  filter: VehicleMonitoringFilterParams,
  cleanFilter: Function,
  applyFilter: Function,
  style?: any
};

export const VehicleMonitoringFilter = ({
  style,
  filter,
  cleanFilter,
  applyFilter
}: Props) => (
  <SpoilerContent style={{ ...style }}>
    <FilterContainer>
      <Filter
        cleanFilter={cleanFilter}
        applyFilter={applyFilter}
        initialValues={filter}
      >
        {({
          values,
          changeValue,
          applyFilter,
          cleanFilter
        }: FilterChildrenParams<VehicleMonitoringFilterParams>) => (
          <>
            <FilterItem>
              <Field mBottomNone>
                <RangePicker
                  format="DD.MM.YYYY"
                  size="small"
                  placeholder={['Начало', 'Конец']}
                  value={[
                    values.startDate ? moment.utc(values.startDate) : null,
                    values.endDate ? moment.utc(values.endDate) : null
                  ]}
                  onChange={(value, dateString) => {
                    const [startDate, endDate] = value;
                    const [startDateString, endDateString] = dateString;
                    changeValue(
                      'startDate',
                      formatDateTimeToISOString(startDate, startDateString)
                    );
                    changeValue(
                      'endDate',
                      formatDateTimeToISOString(endDate, endDateString)
                    );
                  }}
                />
              </Field>
            </FilterItem>

            <FilterButtonsContainer
              applyFilter={applyFilter}
              cleanFilter={cleanFilter}
            />
          </>
        )}
      </Filter>
    </FilterContainer>
  </SpoilerContent>
);

export default VehicleMonitoringFilter;
